import { useGetIdentity, useLogout } from '@refinedev/core';
import { Layout, Avatar, Typography, Dropdown, Space, theme } from 'antd';
import { UserOutlined, LogoutOutlined, DownOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { LanguageSwitcher } from '@/components/common/LanguageSwitcher';
import { ThemeModeSwitcher } from '@/components/common/ThemeModeSwitcher';

const { Header: AntdHeader } = Layout;
const { Text } = Typography;

export const Header = () => {
  const { data: identity } = useGetIdentity<{
    id: string;
    name: string;
    email?: string;
    role?: string;
    avatar?: string;
  }>();
  const { mutate: logout } = useLogout();
  const { token } = theme.useToken();

  const menuItems: MenuProps['items'] = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: identity?.name || 'User',
      disabled: true,
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      onClick: () => logout(),
    },
  ];

  return (
    <AntdHeader
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        position: 'sticky',
        top: 0,
        zIndex: 1,
        padding: '0 24px',
        backgroundColor: token.colorBgContainer,
        borderBottom: `${token.lineWidth}px solid ${token.colorBorderSecondary}`,
      }}
    >
      <Space size="middle">
        <ThemeModeSwitcher />
        <LanguageSwitcher />

        <Dropdown menu={{ items: menuItems }} trigger={['click']}>
          <Space style={{ cursor: 'pointer' }}>
            <Avatar
              size="small"
              icon={<UserOutlined />}
              src={identity?.avatar}
            />
            <Text>{identity?.name || 'User'}</Text>
            {identity?.role && (
              <Text type="secondary" style={{ fontSize: '12px' }}>
                ({identity.role})
              </Text>
            )}
            <DownOutlined style={{ fontSize: '10px' }} />
          </Space>
        </Dropdown>
      </Space>
    </AntdHeader>
  );
};
